import ColorStatusCell from "./ColorStatusCell";

export default ColorStatusCell;